var map = {
	"./copy.png": "mUm2",
	"./next.png": "Ayrv",
	"./support1.png": "iHZj",
	"./support2.png": "EGV7",
	"./support3.png": "/jcA",
	"./support4.png": "92/X",
	"./support5.png": "txyd",
	"./support6.png": "6r+U",
	"./support7.png": "wBO3",
	"./support8.png": "4JMN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1K12";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support \.png$
// module id = 1K12
// module chunks = 0